<app-layout>
    <mat-toolbar class="page-header" role="heading">
        <h1 appLocalizationPopupDirective localizationCode="TimeOffBuySellHoursReport">{{ 'TimeOffBuySellHoursReport' | translate: {Default: "Time Off Buy Sell Hours Report"} }}</h1>
    </mat-toolbar>

    <div class="content">
        <app-data-grid-comp
            [gridId]="gridId"
            [isLoading]="isLoading"
            [height]="750"
            [columns]="columns"
            [gridDataResult]="gridDataResult"
            [pageSize]="pageSize"
            [skip]="skip"
            export="customExcel"
            [sortable]="{
                mode: 'multiple'
            }"
            hideActionButtons="true"
            filterable="false"
            [filterCategories]="filterCategories"
            [sortableColumns]="sortableColumns"
            (emitGridStateChangeEvent)="gridStateChange($event)"
            (emitExportEvent)="allData()"
        ></app-data-grid-comp>
        
        <kendo-excelexport
            [data]="excelData"
            [fileName]="fileName"
            #excelexport
        >
            <kendo-excelexport-column
                *ngFor="let column of excelColumns"
                [field]="column.field"
                [title]="column.title"
            >
            </kendo-excelexport-column>
        </kendo-excelexport>
    </div>
</app-layout>
